import type { QuestionWithSaved } from "~vue/api/generated/reflections";

/**
 * Returns true when the question has a meaningful response:
 * - Score question: score selected OR "not observed" checked.
 * - Text question: non-empty text.
 */
export function isQuestionAnswered(q: QuestionWithSaved): boolean {
    if (q.type === "Score") {
        return q.saved.score != null || q.saved.not_observed === true;
    }
    return (q.saved.text ?? "").trim().length > 0;
}

/**
 * Returns true when a question is required but has not been answered.
 */
export function isRequiredUnanswered(q: QuestionWithSaved): boolean {
    return !q.is_optional && !isQuestionAnswered(q);
}

// Question text templates are stored in the DB with a `{{ name }}` placeholder
// so the same rows can power both 360s (subject varies) and self reflections
// (subject is the viewer). Callers pass the correct name for their context.
const NAME_PLACEHOLDER_RE = /\{\{\s*name\s*\}\}/g;

export function resolveQuestionName(text: string, subjectFirstName: string): string {
    return text.replace(NAME_PLACEHOLDER_RE, subjectFirstName);
}

const ORDINAL_WORDS = ["One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve"];

export function ordinalWord(n: number): string {
    return ORDINAL_WORDS[n - 1] ?? String(n);
}

/**
 * Returns the list of required questions that have not been answered.
 */
export function getUnansweredRequired(questions: QuestionWithSaved[]): QuestionWithSaved[] {
    return questions.filter(isRequiredUnanswered);
}
